/**
 * @generated SignedSource<<589f392f2f31129854ee4f975cbfff87>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WebCrawlScope = "domain" | "single_page" | "subpath" | "%future added value";
export type RefreshTrainingSourceInput = {
  expect?: string | null;
  id: string;
  webCrawlConfig?: WebCrawlConfigInput | null;
};
export type WebCrawlConfigInput = {
  excludeUrlGlobs?: ReadonlyArray<string> | null;
  includeUrlGlobs?: ReadonlyArray<string> | null;
  scope?: WebCrawlScope | null;
};
export type RecrawlTrainingSourceButtonMutation$variables = {
  input: RefreshTrainingSourceInput;
};
export type RecrawlTrainingSourceButtonMutation$data = {
  readonly response: {
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
    readonly node: {
      readonly " $fragmentSpreads": FragmentRefs<"TrainingSourceListItemFragment">;
    } | null;
  };
};
export type RecrawlTrainingSourceButtonMutation = {
  response: RecrawlTrainingSourceButtonMutation$data;
  variables: RecrawlTrainingSourceButtonMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "ValidationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "field",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RecrawlTrainingSourceButtonMutation",
    "selections": [
      {
        "alias": "response",
        "args": (v1/*: any*/),
        "concreteType": "RefreshTrainingSource",
        "kind": "LinkedField",
        "name": "refreshTrainingSource",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TrainingSource",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TrainingSourceListItemFragment"
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RecrawlTrainingSourceButtonMutation",
    "selections": [
      {
        "alias": "response",
        "args": (v1/*: any*/),
        "concreteType": "RefreshTrainingSource",
        "kind": "LinkedField",
        "name": "refreshTrainingSource",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TrainingSource",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "kind",
                "storageKey": null
              },
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TrainingSourceMetadata",
                "kind": "LinkedField",
                "name": "metadata",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TrainingSourceWebCrawlMetadata",
                    "kind": "LinkedField",
                    "name": "web_crawl",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "WebCrawlConfig",
                        "kind": "LinkedField",
                        "name": "config",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "scope",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "excludeUrlGlobs",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "requests",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TrainingDataNodeConnection",
                "kind": "LinkedField",
                "name": "trainingData",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TrainingDataNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TrainingData",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v5/*: any*/),
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "textContent",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TrainingDataMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TrainingDataWebCrawlMetadata",
                                "kind": "LinkedField",
                                "name": "web_crawl",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "title",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "resyncPeriod",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "54717d552ce4e462d0cfa4b70bed8d25",
    "id": null,
    "metadata": {},
    "name": "RecrawlTrainingSourceButtonMutation",
    "operationKind": "mutation",
    "text": "mutation RecrawlTrainingSourceButtonMutation(\n  $input: RefreshTrainingSourceInput!\n) {\n  response: refreshTrainingSource(input: $input) {\n    node {\n      ...TrainingSourceListItemFragment\n      id\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n\nfragment TrainingSourceListItemFragment on TrainingSource {\n  id\n  status\n  kind\n  url\n  metadata {\n    web_crawl {\n      config {\n        scope\n      }\n      requests\n    }\n  }\n  trainingData {\n    totalCount\n    edges {\n      node {\n        id\n        name\n        url\n        textContent\n        metadata {\n          web_crawl {\n            title\n          }\n        }\n      }\n    }\n  }\n  ...TrainingSourceSettingsFormFragment\n}\n\nfragment TrainingSourceSettingsFormFragment on TrainingSource {\n  id\n  kind\n  url\n  name\n  resyncPeriod\n  metadata {\n    web_crawl {\n      config {\n        scope\n        excludeUrlGlobs\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "fe2c6855c7952d216ffe9c17344c05ea";

export default node;
